
import { API_CONFIG } from '../services/avatarSaveService';

interface UploadTestResult {
  isAvailable: boolean;
  error?: string;
  responseTime?: number;
  statusCode?: number;
}

export async function testS3UploadEndpoint(): Promise<UploadTestResult> {
  const startTime = Date.now();
  
  try {
        
    const testImageData = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';
    
    
    const base64Data = testImageData.replace(/^data:image\/png;base64,/, '');
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });

    
    const formData = new FormData();
    formData.append('file', blob, 'test-connectivity.png');
    formData.append('folder', 'test');
    formData.append('public', 'true');
    
    
    const response = await fetch(`${API_CONFIG.baseURL}/upload/s3`, {
      method: 'POST',
      headers: {
        'Authorization': API_CONFIG.token,
      },
      body: formData
    });
    
    const responseTime = Date.now() - startTime;
    
    if (response.ok) {
      const result = await response.json();
            return {
        isAvailable: true,
        responseTime,
        statusCode: response.status
      };
    } else {
      const errorText = await response.text();
            return {
        isAvailable: false,
        error: `HTTP ${response.status}: ${errorText}`,
        responseTime,
        statusCode: response.status
      };
    }
    
  } catch (error) {
    const responseTime = Date.now() - startTime;
        return {
      isAvailable: false,
      error: error instanceof Error ? error.message : 'Erro desconhecido',
      responseTime
    };
  }
}

export function monitorS3Availability(
  onStatusChange: (isAvailable: boolean, result: UploadTestResult) => void,
  intervalMs = 30000 
): () => void {
  let isMonitoring = true;
  let lastStatus: boolean | null = null;
  
  async function checkStatus() {
    if (!isMonitoring) return;
    
    try {
      const result = await testS3UploadEndpoint();
      
      if (lastStatus !== result.isAvailable) {
        lastStatus = result.isAvailable;
        onStatusChange(result.isAvailable, result);
      }
    } catch (error) {
          }
    
    if (isMonitoring) {
      setTimeout(checkStatus, intervalMs);
    }
  }
  
  
  checkStatus();
  
  
  return () => {
    isMonitoring = false;
  };
}

export { API_CONFIG };
